if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = Array.from(this.querySelectorAll('.announcement'));
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      this.autoRotateTimer = null;
      this.isAutoRotate = this.dataset.autoRotate === 'true';
      this.rotateInterval = parseInt(this.dataset.rotateInterval) || 5000;

      if (this.isAutoRotate) {
        // Clone first slide and append to end for seamless looping
        this.cloned = this.content[0].cloneNode(true);
        this.slider.appendChild(this.cloned);
        // Set slider and slide widths
        this.slider.style.width = `${(this.length + 1) * 100}%`;
        Array.from(this.slider.children).forEach(el => {
          el.style.width = `${100 / (this.length + 1)}%`;
          el.style.flex = `0 0 ${100 / (this.length + 1)}%`;
        });
      }

      // Manual navigation
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          if (this.isAutoRotate) {
            this.goToSlide(this.index + 1);
          } else {
            this.scrollToSlide(this.index + 1);
          }
        });
      }
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          if (this.isAutoRotate) {
            this.goToSlide(this.index - 1);
          } else {
            this.scrollToSlide(this.index - 1);
          }
        });
      }

      // Pause on hover, resume on leave
      this.addEventListener('mouseenter', () => {
        this.pauseAutoRotate();
      });
      this.addEventListener('mouseleave', () => {
        this.resumeAutoRotate();
      });

      // Initial position
      if (this.isAutoRotate) {
        this.goToSlide(0, false);
      } else {
        this.scrollToSlide(0, false);
        this.updateNavButtons();
      }

      // Start auto-rotate
      if (this.isAutoRotate && this.length > 1) {
        this.startAutoRotate();
      }
    }

    goToSlide(idx, animate = true) {
      if (!this.isAutoRotate) return;
      if (idx > this.length) return;
      if (idx < 0) idx = this.length - 1;

      this.index = idx;
      const duration = Math.min(this.rotateInterval * 0.5, 1000); // max 1s for smoothness
      this.slider.style.transition = animate ? `transform ${duration}ms cubic-bezier(.4,0,.2,1)` : 'none';
      this.slider.style.transform = `translateX(-${this.index * (100 / (this.length + 1))}%)`;

      // If at the clone, jump to real first slide after animation
      if (this.index === this.length) {
        setTimeout(() => {
          this.slider.style.transition = 'none';
          this.slider.style.transform = `translateX(0%)`;
          this.index = 0;
        }, duration);
      }
    }

    scrollToSlide(idx, smooth = true) {
      if (this.isAutoRotate) return;
      if (idx < 0) idx = 0;
      if (idx >= this.length) idx = this.length - 1;
      this.index = idx;
      const slideWidth = this.content[0].offsetWidth;
      this.slider.scrollTo({
        left: this.index * slideWidth,
        behavior: smooth ? 'smooth' : 'auto'
      });
      this.updateNavButtons();
    }

    updateNavButtons() {
      if (!this.nextButton || !this.prevButton) return;
      this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled');
      if (this.index === 0) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled');
      }
      if (this.index === this.length - 1) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled');
      }
    }

    startAutoRotate() {
      if (!this.isAutoRotate || this.length <= 1) return;
      this.autoRotateTimer = setInterval(() => {
        this.goToSlide(this.index + 1);
      }, this.rotateInterval);
    }

    pauseAutoRotate() {
      if (this.autoRotateTimer) {
        clearInterval(this.autoRotateTimer);
        this.autoRotateTimer = null;
      }
    }

    resumeAutoRotate() {
      if (this.isAutoRotate && this.length > 1 && !this.autoRotateTimer) {
        this.startAutoRotate();
      }
    }
  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}